module.exports = __webpack_public_path__ + "img/CPCPickup.08311986.svg";